import React from 'react'

const GrayText: React.FC<{ text: string | React.ReactNode }> = ({ text }) => (
  <p className="p-0 m-0" style={{ color: 'rgb(153, 153, 153)' }}>
    {text}
  </p>
)

export default GrayText
